import { useFeaturedVideosModal } from '~/composables/useFeaturedVideosModal';
import { usePropertyViewTracking } from '~/composables/usePropertyViewTracking';
import { useFeaturedVideosStore } from '~/store/featuredVideosStore';

export default defineNuxtPlugin(() => {
	const { ft_poc_videos } = useFeatureFlags();

	if (!ft_poc_videos) return;

	const { loggedIn } = useUserSession();
	const { syncOfflineViews, getOfflineViewsCount } = usePropertyViewTracking();
	const featuredVideosStore = useFeaturedVideosStore();
	const { resetState: resetModalState } = useFeaturedVideosModal();

	watch(loggedIn, async (isLoggedIn, wasLoggedIn) => {
		if (isLoggedIn && !wasLoggedIn) {
			const offlineCount = getOfflineViewsCount();
			if (offlineCount > 0) {
				try {
					await syncOfflineViews();
				} finally {
					featuredVideosStore.reset();
					resetModalState();
				}
			}
		}
	});
});
